import { HttpModule } from '@angular/http';
import { PrintSlideComponent } from './content/libs/carousel/slide/print-slide.component';
import { SlideAjaxDivComponent } from './content/libs/carousel/slide/slide-ajax-div.component';
import { ContentSliderComponent } from './content/libs/carousel/content-slider.component';
import { PriceComponent } from './content/price/price.component';
import { GalleryComponent } from './content/gallery/gallery.component';
import { NotFoundComponent } from './content/404/not-found.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { ContactComponent } from './content/contact/contact.component';
import { HomeComponent } from './content/home/home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MiniatureListComponent } from './content/contact/miniature-list/miniature-list.component';
import { NumberPickerComponent } from './content/contact/number-picker/number-picker.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MdButtonModule, MdCheckboxModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import { MaterialModule, MdNativeDateModule } from '@angular/material';
import { ImageCardComponent } from './content/libs/image-card/image-card.component';
import { SafePipePipe } from './pipes/safe-pipe.pipe';
import { Parallax, ParallaxConfig } from 'ng2-parallax/commonjs';
import { CompareSliderComponent } from './content/libs/compare-slider/compare-slider.component';
import { ImageZoomComponent } from './content/libs/image-zoom/image-zoom.component';
import { AgbComponent } from './content/agb/agb.component';
import { ThreeSixtyViewComponent } from './content/libs/three-sixty-view/three-sixty-view.component';

const appRoutes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'gallery', component: GalleryComponent },
  { path: 'preice', component: PriceComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'agb', component: AgbComponent },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  { path: '**', component: NotFoundComponent }
]
@NgModule({
  declarations: [
    AppComponent,
    ContactComponent,
    HomeComponent,
    GalleryComponent,
    PriceComponent,
    NotFoundComponent,
    MiniatureListComponent,
    NumberPickerComponent,
    ContentSliderComponent,
    SlideAjaxDivComponent,
    PrintSlideComponent,
    ImageCardComponent,
    SafePipePipe,
    CompareSliderComponent,
    Parallax,
    ImageZoomComponent,
    AgbComponent,
    ThreeSixtyViewComponent,
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    FormsModule,
    NoopAnimationsModule,
    MaterialModule,
    MdNativeDateModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MdCheckboxModule,
    ReactiveFormsModule,
    HttpModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/app.module.ts